import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { reportsPost } from "../../store/reports/actions";
export var useApiPostReports = function (trigger, reportBody) {
    var dispatch = useDispatch();
    var _a = useSelector(function (state) {
        var _a;
        return ({
            loadingReports: state.Reports.loadingReports,
            responseReports: (_a = state.Reports.responseReports) === null || _a === void 0 ? void 0 : _a.data,
            errorReports: state.Reports.errorReports,
        });
    }), loadingReports = _a.loadingReports, responseReports = _a.responseReports, errorReports = _a.errorReports;
    useEffect(function () {
        if (trigger) {
            dispatch(reportsPost(reportBody));
        }
    }, [trigger, reportBody]);
    return {
        loadingReports: loadingReports,
        responseReports: responseReports,
        errorReports: errorReports,
    };
};
